import { bl_inv_pdg_guide_element_RowClass } from '../../dbschema';
import { BaseContainerModel } from '../base-container.model';

export class InventoryPdgGuideElementContainerModel extends BaseContainerModel {
  bl_inv_pdg_guide_element: bl_inv_pdg_guide_element_RowClass = new bl_inv_pdg_guide_element_RowClass();
}
